// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Formality from "../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Caml_option from "../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as EventTracker from "../../../../../../library/event-tracker/react-ga/EventTracker.bs.js";
import * as FormTextArea from "../../../../../../library/components/generic-components/components/FormTextArea.bs.js";
import * as Row$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as ProgressModal from "../../../../../../library/components/generic-components/components/ProgressModal.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as DeliveryNoteVm from "../../view-model/DeliveryNoteVm.bs.js";
import * as Switch$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/switch/Switch.bs.js";
import * as DeliveryNoteType from "../../../../../../library/data-source/order/entity/DeliveryNoteType.bs.js";
import * as DeliveryNoteStatus from "../../../../../../library/data-source/order/entity/DeliveryNoteStatus.bs.js";
import * as FormInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";
import * as FormHelper$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as EditOrderDataMachine from "../../../app/repo/EditOrderDataMachine.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as SubmitModalConfirmation from "../sidebars/SubmitModalConfirmation.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SecondaryButton$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SecondaryButton.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as FormCheckBoxInput$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormCheckBoxInput.bs.js";

function getDNStatusOption(dn_status) {
  return {
          key: dn_status,
          value: dn_status.toUpperCase(),
          text: dn_status
        };
}

var dnStatusList_0 = getDNStatusOption("Requested");

var dnStatusList_1 = {
  hd: getDNStatusOption("Pending"),
  tl: {
    hd: getDNStatusOption("Delivered"),
    tl: {
      hd: getDNStatusOption("Cancelled"),
      tl: /* [] */0
    }
  }
};

var dnStatusList = {
  hd: dnStatusList_0,
  tl: dnStatusList_1
};

var dnTypeList = {
  hd: {
    id: "0",
    label: "Delivery note",
    value: "HARDCOPY"
  },
  tl: {
    hd: {
      id: "0",
      label: "E-Delivery note",
      value: "SOFTCOPY"
    },
    tl: /* [] */0
  }
};

function isDNStatusDisabled(dnStatus, country) {
  if (country.TAG === /* India */1 || dnStatus === 1) {
    return true;
  } else {
    return dnStatus >= 3;
  }
}

function isStatusChangeValid(initial_value, changed_value) {
  if (initial_value === undefined) {
    return false;
  }
  if (changed_value === undefined) {
    return false;
  }
  var match = initial_value.value;
  switch (match) {
    case "PENDING" :
        if (changed_value !== 1) {
          return changed_value >= 3;
        } else {
          return true;
        }
    case "REQUESTED" :
        return changed_value !== 0;
    default:
      return false;
  }
}

function getDNStatusPayload(initial_status, final_status, dn_type) {
  var match = isStatusChangeValid(initial_status, final_status);
  if (match && final_status !== undefined) {
    return {
            hd: {
              status: DeliveryNoteStatus.toString(final_status),
              dn_type: dn_type
            },
            tl: /* [] */0
          };
  } else {
    return /* [] */0;
  }
}

var validators_additionalComment = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var additionalComment = param.additionalComment;
      if (additionalComment === "") {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: additionalComment
              };
      }
    })
};

var validators_softcopy_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var softcopy_status = param.softcopy_status;
      if (softcopy_status !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: DeliveryNoteStatus.fromString(softcopy_status.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_hardcopy_status = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var hardcopy_status = param.hardcopy_status;
      if (hardcopy_status !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: DeliveryNoteStatus.fromString(hardcopy_status.value)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators = {
  additionalComment: validators_additionalComment,
  softcopy_status: validators_softcopy_status,
  hardcopy_status: validators_hardcopy_status
};

function initialFieldsStatuses(_input) {
  return {
          additionalComment: /* Pristine */0,
          softcopy_status: /* Pristine */0,
          hardcopy_status: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            additionalComment: /* Pristine */0,
            softcopy_status: /* Pristine */0,
            hardcopy_status: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.additionalComment;
  var match_0 = match ? match._0 : Curry._1(validators.additionalComment.validate, input);
  var match$1 = fieldsStatuses.softcopy_status;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.softcopy_status.validate, input);
  var match$2 = fieldsStatuses.hardcopy_status;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.hardcopy_status.validate, input);
  var additionalCommentResult = match_0;
  var additionalCommentResult$1;
  if (additionalCommentResult.TAG === /* Ok */0) {
    var softcopy_statusResult = match_0$1;
    if (softcopy_statusResult.TAG === /* Ok */0) {
      var hardcopy_statusResult = match_0$2;
      if (hardcopy_statusResult.TAG === /* Ok */0) {
        return {
                TAG: /* Valid */0,
                output: {
                  hardcopy_status: hardcopy_statusResult._0,
                  softcopy_status: softcopy_statusResult._0,
                  additionalComment: additionalCommentResult._0
                },
                fieldsStatuses: {
                  additionalComment: /* Dirty */{
                    _0: additionalCommentResult,
                    _1: /* Shown */0
                  },
                  softcopy_status: /* Dirty */{
                    _0: softcopy_statusResult,
                    _1: /* Shown */0
                  },
                  hardcopy_status: /* Dirty */{
                    _0: hardcopy_statusResult,
                    _1: /* Shown */0
                  }
                },
                collectionsStatuses: undefined
              };
      }
      additionalCommentResult$1 = additionalCommentResult;
    } else {
      additionalCommentResult$1 = additionalCommentResult;
    }
  } else {
    additionalCommentResult$1 = additionalCommentResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            additionalComment: /* Dirty */{
              _0: additionalCommentResult$1,
              _1: /* Shown */0
            },
            softcopy_status: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            hardcopy_status: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurAdditionalCommentField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.additionalComment, validators_additionalComment, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  additionalComment: status,
                                  softcopy_status: init.softcopy_status,
                                  hardcopy_status: init.hardcopy_status
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSoftcopy_statusField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.softcopy_status, validators_softcopy_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  additionalComment: init.additionalComment,
                                  softcopy_status: status,
                                  hardcopy_status: init.hardcopy_status
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurHardcopy_statusField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.hardcopy_status, validators_hardcopy_status, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  additionalComment: init.additionalComment,
                                  softcopy_status: init.softcopy_status,
                                  hardcopy_status: status
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */3 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */3,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */4,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */6);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */5);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */4 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */5 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */6 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateAdditionalCommentField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, state.fieldsStatuses.additionalComment, state.submissionStatus, validators_additionalComment, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            additionalComment: status,
                                            softcopy_status: init.softcopy_status,
                                            hardcopy_status: init.hardcopy_status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSoftcopy_statusField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, state.fieldsStatuses.softcopy_status, state.submissionStatus, validators_softcopy_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            additionalComment: init.additionalComment,
                                            softcopy_status: status,
                                            hardcopy_status: init.hardcopy_status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateHardcopy_statusField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, state.fieldsStatuses.hardcopy_status, state.submissionStatus, validators_hardcopy_status, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            additionalComment: init.additionalComment,
                                            softcopy_status: init.softcopy_status,
                                            hardcopy_status: status
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */3 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                additionalComment: /* Pristine */0,
                                softcopy_status: /* Pristine */0,
                                hardcopy_status: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                additionalComment: /* Pristine */0,
                                softcopy_status: /* Pristine */0,
                                hardcopy_status: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */4 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */5 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateAdditionalComment: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAdditionalCommentField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSoftcopy_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSoftcopy_statusField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateHardcopy_status: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHardcopy_statusField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurAdditionalComment: (function (param) {
              return Curry._1(dispatch, /* BlurAdditionalCommentField */0);
            }),
          blurSoftcopy_status: (function (param) {
              return Curry._1(dispatch, /* BlurSoftcopy_statusField */1);
            }),
          blurHardcopy_status: (function (param) {
              return Curry._1(dispatch, /* BlurHardcopy_statusField */2);
            }),
          additionalCommentResult: Formality.exposeFieldResult(state.fieldsStatuses.additionalComment),
          softcopy_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.softcopy_status),
          hardcopy_statusResult: Formality.exposeFieldResult(state.fieldsStatuses.hardcopy_status),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.additionalComment || match.softcopy_status || match.hardcopy_status) {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */3);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */4);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */5);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */5,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */6);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function DeliveryNoteForm(Props) {
  var initial_input = Props.initial_input;
  var is_dn_requested = Props.is_dn_requested;
  var dn_types = Props.dn_types;
  var order_id = Props.order_id;
  var user = Props.user;
  var toggleEditOrderSidebar = Props.toggleEditOrderSidebar;
  var changeDiscardModalState = Props.changeDiscardModalState;
  var openSnackbar = Props.openSnackbar;
  var match = React.useState(function () {
        return false;
      });
  var toggleSaveModal = match[1];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var match$2 = React.useState(function () {
        return false;
      });
  var setSubmittingModal = match$2[1];
  var isFormSubmissionValid = function (form_data) {
    var match = form_data.hardcopy_status;
    var match$1 = form_data.softcopy_status;
    if (match === undefined) {
      if (match$1 !== undefined) {
        return isStatusChangeValid(initial_input.softcopy_status, DeliveryNoteStatus.fromString(match$1.value));
      } else {
        return false;
      }
    }
    if (match$1 === undefined) {
      return isStatusChangeValid(initial_input.hardcopy_status, DeliveryNoteStatus.fromString(match.value));
    }
    var data = match.value;
    switch (data) {
      case "PENDING" :
          var data$1 = match$1.value;
          if (data$1 === "REQUESTED") {
            return false;
          } else if (isStatusChangeValid(initial_input.softcopy_status, DeliveryNoteStatus.fromString(data$1))) {
            return true;
          } else {
            return isStatusChangeValid(initial_input.hardcopy_status, /* Pending */2);
          }
      case "REQUESTED" :
          var data$2 = match$1.value;
          if (data$2 === "PENDING") {
            return false;
          } else {
            return isStatusChangeValid(initial_input.softcopy_status, DeliveryNoteStatus.fromString(data$2));
          }
      default:
        if (isStatusChangeValid(initial_input.hardcopy_status, DeliveryNoteStatus.fromString(data))) {
          return true;
        } else {
          return isStatusChangeValid(initial_input.softcopy_status, DeliveryNoteStatus.fromString(match$1.value));
        }
    }
  };
  var form = useForm(initial_input, (function (output, _submissionCallbacks) {
          var payload_admin_id = user.id;
          var payload_admin_name = user.name;
          var payload_delivery_note = {
            is_requested: is_dn_requested,
            details: List.append(getDNStatusPayload(initial_input.hardcopy_status, output.hardcopy_status, "HARDCOPY"), List.append(getDNStatusPayload(initial_input.softcopy_status, output.softcopy_status, "SOFTCOPY"), /* [] */0)),
            comments: output.additionalComment
          };
          var payload = {
            crn: order_id,
            admin_id: payload_admin_id,
            admin_name: payload_admin_name,
            delivery_note: payload_delivery_note
          };
          return EditOrderDataMachine.updateDeliveryNote(payload, (function (_data) {
                        Curry._1(toggleEditOrderSidebar, undefined);
                        Curry._1(changeDiscardModalState, (function (param) {
                                return false;
                              }));
                        Curry._1(setSubmittingModal, (function (param) {
                                return false;
                              }));
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: "Order Updated Successfully"
                            });
                        return EventTracker.publishEvent({
                                    category: "Edit Order GA4",
                                    action: "New Edit Order submit Successful",
                                    label: "Delivery Note",
                                    value: undefined,
                                    nonInteraction: undefined
                                  });
                      }), (function (error) {
                        Curry._1(openSnackbar, {
                              TAG: /* Error */1,
                              _0: ErrorUtils$Catalyst.resolveError(error)
                            });
                        EventTracker.publishEvent({
                              category: "Edit Order GA4",
                              action: "New Edit Order submit Failure",
                              label: "Delivery Note",
                              value: undefined,
                              nonInteraction: undefined
                            });
                        return Curry._1(setSubmittingModal, (function (param) {
                                      return false;
                                    }));
                      }), country);
        }));
  var status = initial_input.hardcopy_status;
  var isDNFormDisbaled = false;
  if (status !== undefined ? isDNStatusDisabled(DeliveryNoteStatus.fromString(status.value), country) : true) {
    var status$1 = initial_input.softcopy_status;
    isDNFormDisbaled = status$1 !== undefined ? isDNStatusDisabled(DeliveryNoteStatus.fromString(status$1.value), country) : true;
  }
  var tmp;
  if (is_dn_requested) {
    var tmp$1;
    var exit = 0;
    switch (country.TAG | 0) {
      case /* UAE */0 :
      case /* TR */3 :
          exit = 1;
          break;
      default:
        tmp$1 = null;
    }
    if (exit === 1) {
      tmp$1 = React.createElement(React.Fragment, undefined, React.createElement("label", undefined, "How you want " + DeliveryNoteVm.getDNName(country) + " copy?"), React.createElement(FormCheckBoxInput$Catalyst.make, {
                input_props: FormInput$Catalyst.make_props("", undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "delivery-note-type", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                checkbox_props: {
                  selected: List.map(DeliveryNoteType.toString, dn_types),
                  options: dnTypeList,
                  row_layout: true
                }
              }));
    }
    var hardcopy_status = initial_input.hardcopy_status;
    var softcopy_status = initial_input.softcopy_status;
    tmp = React.createElement(Row$Catalyst.make, {
          children: React.createElement("div", undefined, tmp$1, React.createElement("div", undefined, React.createElement("label", undefined, DeliveryNoteVm.getDNNameCaps(country) + " Status"), hardcopy_status !== undefined ? React.createElement(Row$Catalyst.make, {
                          children: null,
                          className: "delivery-note-status-container"
                        }, React.createElement("div", {
                              className: "dn-type"
                            }, "Hardcopy Status"), React.createElement(FormSelectInput$Catalyst.make, {
                              input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                      return Curry._2(form.updateHardcopy_status, (function (input, value) {
                                                    return {
                                                            hardcopy_status: value,
                                                            softcopy_status: input.softcopy_status,
                                                            additionalComment: input.additionalComment
                                                          };
                                                  }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), dnStatusList));
                                    }), isDNStatusDisabled(DeliveryNoteStatus.fromString(hardcopy_status.value), country), undefined, "Select the " + DeliveryNoteVm.getDNNameSmall(country) + " status", undefined, undefined, undefined, form.hardcopy_statusResult, undefined, "delivery-note-status", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                              select_props: {
                                value: form.input.hardcopy_status,
                                items: dnStatusList,
                                isNoneRequired: false
                              }
                            })) : null, softcopy_status !== undefined ? React.createElement(Row$Catalyst.make, {
                          children: null,
                          className: "delivery-note-status-container"
                        }, React.createElement("div", {
                              className: "dn-type"
                            }, "Softcopy Status"), React.createElement(FormSelectInput$Catalyst.make, {
                              input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                                      return Curry._2(form.updateSoftcopy_status, (function (input, value) {
                                                    return {
                                                            hardcopy_status: input.hardcopy_status,
                                                            softcopy_status: value,
                                                            additionalComment: input.additionalComment
                                                          };
                                                  }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), dnStatusList));
                                    }), isDNStatusDisabled(DeliveryNoteStatus.fromString(softcopy_status.value), country), undefined, "Select the " + DeliveryNoteVm.getDNNameSmall(country) + " status", undefined, undefined, undefined, form.softcopy_statusResult, undefined, "delivery-note-status", undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                              select_props: {
                                value: form.input.softcopy_status,
                                items: dnStatusList,
                                isNoneRequired: false
                              }
                            })) : null), React.createElement("label", undefined, "Comments (Optional)"), React.createElement(FormTextArea.make, {
                    input_props: FormInput$Catalyst.make_props("", (function ($$event) {
                            return Curry._2(form.updateAdditionalComment, (function (input, value) {
                                          return {
                                                  hardcopy_status: input.hardcopy_status,
                                                  softcopy_status: input.softcopy_status,
                                                  additionalComment: value
                                                };
                                        }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                          }), isDNFormDisbaled, undefined, "Add any additional comments", undefined, undefined, undefined, form.additionalCommentResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                    textinput_props: {
                      value: form.input.additionalComment
                    }
                  }))
        });
  } else {
    tmp = null;
  }
  var match$3 = form.status;
  var tmp$2;
  var exit$1 = 0;
  if (typeof match$3 === "number") {
    if (match$3 === /* Editing */0) {
      exit$1 = 1;
    } else {
      Curry._1(toggleEditOrderSidebar, undefined);
      Curry._1(changeDiscardModalState, (function (param) {
              return false;
            }));
      tmp$2 = null;
    }
  } else if (match$3.TAG === /* Submitting */0) {
    tmp$2 = null;
  } else {
    exit$1 = 1;
  }
  if (exit$1 === 1) {
    tmp$2 = React.createElement(SubmitModalConfirmation.make, {
          isOpen: match[0],
          onCancel: (function (param) {
              return Curry._1(toggleSaveModal, (function (param) {
                            return false;
                          }));
            }),
          onSubmit: (function (param) {
              Curry._1(toggleSaveModal, (function (param) {
                      return false;
                    }));
              return Curry._1(form.submit, undefined);
            })
        });
  }
  return React.createElement(React.Fragment, undefined, React.createElement("form", {
                  className: "delivery-note-form",
                  onSubmit: (function ($$event) {
                      $$event.preventDefault();
                      
                    })
                }, React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement("label", undefined, "This order includes " + DeliveryNoteVm.getDNName(country)), React.createElement(Switch$Catalyst.make, {
                          checked: is_dn_requested,
                          on_change: (function (_event) {
                              
                            }),
                          disabled: true,
                          switch_color: /* Primary */1
                        })), tmp, tmp$2), React.createElement(ProgressModal.make, {
                  isOpen: match$2[0]
                }), React.createElement("div", {
                  className: "footer-container"
                }, React.createElement("div", {
                      className: "c-edit-order-footer"
                    }, React.createElement(SecondaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Text */0,
                                _0: "Close"
                              }, undefined, (function (_event) {
                                  return Curry._1(toggleEditOrderSidebar, undefined);
                                }), undefined, undefined, undefined, undefined, "close-button-enabled", undefined, undefined)
                        }), React.createElement(PrimaryButton$Catalyst.make, {
                          buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                TAG: /* Text */0,
                                _0: "Submit"
                              }, isDNFormDisbaled, (function (_event) {
                                  if (isFormSubmissionValid(form.input)) {
                                    return Curry._1(toggleSaveModal, (function (param) {
                                                  return true;
                                                }));
                                  } else {
                                    return Curry._1(openSnackbar, {
                                                TAG: /* Error */1,
                                                _0: "Select valid entry for " + DeliveryNoteVm.getDNNameCaps(country) + " Status"
                                              });
                                  }
                                }), undefined, undefined, undefined, undefined, isDNFormDisbaled ? "button-disabled" : "submit-button-enabled", undefined, undefined)
                        }))));
}

var make = DeliveryNoteForm;

export {
  getDNStatusOption ,
  dnStatusList ,
  dnTypeList ,
  isDNStatusDisabled ,
  isStatusChangeValid ,
  getDNStatusPayload ,
  Form ,
  make ,
  
}
/* dnStatusList Not a pure module */
